import { Field, getIn } from 'formik';
import React from 'react';

const CustomErrorMessage = ({name}) => (
  <Field 
    name={name}
    render={({ form }) => {
      const error = getIn(form.errors, name);
      const touch = getIn(form.touched, name);
      return touch && error ? 
        <div id="feedback" className="text-danger">{error}</div> :
        null;
    }}
  />
)

export default CustomErrorMessage;




// WEBPACK FOOTER //
// ./src/views/CustomErrorMessage.js